import { Fab, Grid, Paper, Tab, Tabs, Theme, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import merge from 'deepmerge';
import { isBrowser } from 'react-device-detect';
import React, { useGlobal } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import ProgressBar from '../../progress/ProgressBar';
import { SectionTitle } from '../../components/SectionTitle';
import TabPanel from '../../components/TabPanel';
import '../../css/media-query-styles.css';
import { IGlobalState, IMyAppState, initialState } from '../../states/GlobalState';
import { loggaAccesso } from '../../services/common';
import Auth from '../../types/auth';
import { Applicazioni, DefaultInputProps, TabIForfettari, LoadTelematico } from '../../types/types';
import { tabs } from '../../types/constants';
import Collaboratore1 from './Collaboratore1';
import Collaboratore2 from './Collaboratore2';
import Confronto from './Confronto';
import DatiCollaboratore1 from './DatiCollaboratore1';
import DatiCollaboratore2 from './DatiCollaboratore2';
// import Collaboratore1FlatTaxIrpef from './FlatTax/Collaboratore1FlatTaxIrpef';
// import Collaboratore1FlatTaxTuttoIrpef from './FlatTax/Collaboratore1FlatTaxTuttoIrpef';
// import Collaboratore2FlatTaxIrpef from './FlatTax/Collaboratore2FlatTaxIrpef';
// import Collaboratore2FlatTaxTuttoIrpef from './FlatTax/Collaboratore2FlatTaxTuttoIrpef';
// import ContributiFlatTax from './FlatTax/ContributiFlatTax';
// import DatiInformazioniInizialiFlatTax from './FlatTax/DatiInformazioniInizialiFlatTax';
// import DeterminazioneDelRedditoFlatTax from './FlatTax/DeterminazioneDelRedditoFlatTax';
// import GestionePrevidenzialeFlatTax from './FlatTax/GestionePrevidenzialeFlatTax';
// import ImpostaSostitutivaFlatTax from './FlatTax/ImpostaSostitutivaFlatTax';
// import ImprenditoreProfessionistaFlatTaxIrpef from './FlatTax/ImprenditoreProfessionistaFlatTaxIrpef';
// import ImprenditoreProfessionistaFlatTaxTuttoIrpef from './FlatTax/ImprenditoreProfessionistaFlatTaxTuttoIrpef';
// import ImpresaFamiliareFlatTax from './FlatTax/ImpresaFamiliareFlatTax';
// import IrapRegimeNormaleFlatTax from './FlatTax/IrapRegimeNormaleFlatTax';
// import LiquidazioneIrpefDatiImprenditoreProfessionistaFlatTax from './FlatTax/LiquidazioneIrpefDatiImprenditoreProfessionistaFlatTax';
// import ReportElaborazioneFlatTax from './FlatTax/ReportElaborazioneFlatTax';
import GestionePrevidenziale from './GestionePrevidenziale';
import ImprenditoreProfessionista from './ImprenditoreProfessionista';
import InformazioniIniziali from './InformazioniIniziali';
import IrpefCollaboratore1 from './IrpefCollaboratore1';
import IrpefCollaboratore2 from './IrpefCollaboratore2';
import IrpefImprenditore from './IrpefImprenditore';
import LiquidazioneIrpef from './LiquidazioneIrpef';
import RedditoContributiImposta from './RedditoContributiImposta';
import RegimeForfettario from './RegimeForfettario';
import RegimeNormale from './RegimeNormale';
import ReportElaborazione from './ReportElaborazione';
import ComputerIcon from '@material-ui/icons/Computer';
import { API_elaboraIForfetariGlobal } from '../../utils/functions';
import { useLogger } from '../../logger';
import { useHistory } from "react-router-dom";
import Main from '../../components/main';
import { motion } from 'framer-motion';
import { fabVariants } from '../../animation/variants';
import DialogTelematico from '../../telematico/dialogTelematico';
import { loadDatiFromTelematicos } from '../../services/telematicoService';
import { fillDataPFTelematicoToForfetari, fillDataCollabTelematicoToForfetari } from '../../telematico/forfetarioFunctions';

function reducer(state: IMyAppState, action: any = undefined) {
  let s: IMyAppState;
  switch (action.type) {
    case 'setLoading':
      s = {
        ...state,
        loading: action.value
      };
      return s;
    case 'reset':
      return initialState;
    case 'set':
      s = { ...action.value };
      let newState = merge(initialState, s);
      return newState;
    case 'count':
      s = { ...action.value };
      let countState = merge(state, s);
      return countState;
    case 'changeContributiImposta':
      s = {
        ...state,
        redditoContributiImposta: {
          ...state.redditoContributiImposta,
          [action.name]: action.value
        }
      };
      return s;
    case 'changeRegimeForfettario':
      s = {
        ...state,
        regimeForfettario: {
          ...state.regimeForfettario,
          [action.name]: action.value,
        }
      };
      return s;
    case 'changeInformazioniIniziali':
      s = {
        ...state,
        [action.name]: action.value,
      };
      return s;
    case 'changeGestionePrevidenziale':
      s = {
        ...state,
        gestionePrevidenziale: {
          ...state.gestionePrevidenziale,
          [action.name]: action.value,
        }
      };
      return s;
    case 'changeRegimeNormale':
      s = {
        ...state,
        regimeNormale: {
          ...state.regimeNormale,
          [action.name]: action.value,
        }
      };
      return s;
    case 'changeLiquidazioneIrpef':
      s = {
        ...state,
        liquidazioneIrpef: {
          ...state.liquidazioneIrpef,
          [action.name]: action.value,
        }
      };
      return s;
    case 'changeDatiCollaboratore1':
      s = {
        ...state,
        datiCollaboratore1: {
          ...state.datiCollaboratore1,
          [action.name]: action.value,
        }
      };
      return s;
    case 'changeDatiCollaboratore2':
      s = {
        ...state,
        datiCollaboratore2: {
          ...state.datiCollaboratore2,
          [action.name]: action.value,
        }
      };
      return s;
    case 'changeConfronto':
      s = {
        ...state,
        confronto: {
          ...state.confronto,
          [action.name]: action.value,
        }
      };
      return s;
    // case 'changeDatiInformazioniInizialiFlatTax':
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       datiInformazioniInizialiFt: {
    //         ...state.flatTax.datiInformazioniInizialiFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case 'changeGestionePrevidenzialeFlatTax':
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       gestionePrevidenzialeFt: {
    //         ...state.flatTax.gestionePrevidenzialeFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case 'changeDeterminazioneDelRedditoFlatTax':
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       determinazioneDelRedditoFt: {
    //         ...state.flatTax.determinazioneDelRedditoFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case 'changeIrapRegimeNormaleFlatTax':
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       irapRegimeNormaleFt: {
    //         ...state.flatTax.irapRegimeNormaleFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case "changeContributiFlatTax":
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       contributiFt: {
    //         ...state.flatTax.contributiFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case "changeLiquidazioneIrpefDatiImprenditoreProfessionistaFlatTax":
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       liquidazioneIrpefDatiImprenditoreProfessionistaFt: {
    //         ...state.flatTax.liquidazioneIrpefDatiImprenditoreProfessionistaFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case "changeImpresaFamiliareFlatTax":
    //   s = {
    //     ...state,
    //     flatTax: {
    //       ...state.flatTax,
    //       impresaFamiliareFt: {
    //         ...state.flatTax.impresaFamiliareFt,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaFlatTax(s, action);
    // case "changeDatiSimulazioniSrl":
    //   s = {
    //     ...state,
    //     simulazioniSrl: {
    //       ...state.simulazioniSrl,
    //       datiSimulazioniSrl: {
    //         ...state.simulazioniSrl.datiSimulazioniSrl,
    //         [action.name]: action.value
    //       }
    //     }
    //   };
    //   return calcolaSimulazioniSrl(s, action);
    default:
      throw new Error();
  }
  // return calcola(s, action);
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      // width: `calc(100% - ${drawerWidth}px)`,
      // marginLeft: drawerWidth,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    tabsBar: {
      boxShadow: "0px 4px 7px 3px #ccc",
      position: "fixed",
      zIndex: 1000,
      // overflow: 'auto',
      // overflow: 'auto'      
      // width: "100%",
      // marginTop: ""
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.leavingScreen,
      // }),
    },
    tabsBarShift: {
      boxShadow: "0px 4px 7px 3px #ccc",
      position: "fixed",
      zIndex: 1000,
      // marginTop: '12px',
      // overflow: 'auto'
      // width: `calc(100% - ${drawerWidth}px)`,
      // marginLeft: drawerWidth,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    tabColorati: {
      transitionTimingFunction: 'ease-in',
      transition: 'background 0.5s',
      '&:hover': {
        background: theme.palette.secondary.main,
      },
      flex: '0 1 auto',
      // width: ''
    },
    testoColorato: {
      '&:hover': {
        color: '#fff'
      }
    },
    button: {
      backgroundColor: 'rgba(0, 161, 216, 0.8)', // blue[100],
      color: '#fff',
      '&:hover': {
          backgroundColor: 'rgba(0, 161, 216, 1.0)'
      },
      '&:pressed': {
          backgroundColor: 'rgba(0, 161, 216, 1.0)'
      }
    },
    // Media query for the tabs menu, sotto i 400px siamo in flex start
    justifyTabs: {
      paddingTop: '20px',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',        
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.up('lg')]: {
        justifyContent: 'center',
      },
    },
  }),
);

export default function IForfettariHomePage() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  // eslint-disable-next-line
  const [identity] = useGlobal<IGlobalState, 'identity'>('identity');
  const [application, setApplication] = useGlobal<IGlobalState, 'application'>('application');
  const [userLogged, setUserLogged] = useGlobal<IGlobalState, 'userLogged'>('userLogged');
  const [global] = useGlobal<IGlobalState>();
  const [tab, setTab] = React.useState(TabIForfettari.Dati as number);
  const [open,] = React.useState(false);
  const logger = useLogger({key: 'identity'});
  const history = useHistory();
  const [title, ] = useGlobal<IGlobalState, 'title'>('title');
  const [caricaDatiTelematicoOpen, setCaricaDatiTelematicoOpen] = React.useState<boolean>(false);
  const [, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
  const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
  const [ip,] = useGlobal<IGlobalState, 'ip'>('ip');

  let apptabs = tabs;
  // const username = Auth.getUsername(global);
  const username = identity?.Username!;
  // console.log('Sono in HOME PAGE FORFETARI CON USERNAME: ' + username);

  const handleChange = (type: string, name: string, value: any) => {
    // console.log('Handle change home page');
    // console.time('dipatch');
    dispatch({ type, name, value });
    // console.timeEnd('dipatch');
  }

  function handleTabChange(event: React.ChangeEvent<{}>, newValue: TabIForfettari) {
    setTab(newValue);
  }

  function verifyApplicationPrincipal() {
    if (!identity || identity.ApplicationForfetari !== true) {
      // setApplicazione(appId);
      logger.error('Diritto mancante sulla applicazione forfetari');
      history.push('/');
    }
  }
  
  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  //HACK vmorell 20210303
  // Function to calculate forfetari 
  function handleClickCalculateForfetari(stateIForf: IMyAppState) {
    console.log('ho lanciato il calcolo forfettari con lo stato: ' + JSON.stringify(stateIForf))
    let props: DefaultInputProps = {state: stateIForf, handleChange: handleChange, username: username};

    API_elaboraIForfetariGlobal(props, global);
  }  
  //END HACK vmorell

  function handleResetState() {
    dispatch({ type: 'reset' });
    // dispatchSimSrl({ type: 'reset' });
    // dispatchBudget({ type: 'reset' });
  }

  function handleLoadState(newState: IMyAppState, applicazione: number) {
    dispatch({ type: 'set', value: newState });
    // else if (applicazione === Applicazioni.ConvSrl) {
    //   dispatchSimSrl({ type: 'set', value: newState });
    // }
  }
  
  const handleOpenLoadData = () => {
    setCaricaDatiTelematicoOpen(true);
  }
  
  const handleClose = (e: any) => {
    setCaricaDatiTelematicoOpen(false);
    // handleBlur();
  }
  
  const handleSubmitLoadTelematico = (values: LoadTelematico) => {
    // setTimeout(() => {
    //   alert(JSON.stringify(values, null, 2));
    //   // alert('agency: ' + agency)
    //   setSubmitting(false);
    // }, 400);
    setGlobalWait(true);
    console.log('values from form: ' + JSON.stringify(values));
    loadDatiFromTelematicos(ip, auth.authData!, auth.user!, values).then(res => {
      // setForfetarioTelematico(res);      
      console.log('Chiamo la fill forfetari per i 3 personaggi');
      console.log('rES FROM forfetari per is: ' + JSON.stringify(res));      
      if (res.primoCF === null && res.collab1CF === null && res.collab2CF === null) {
        logger.error("Nessun dato recuperato", "Carica telematico");        
      } else {
        fillDataPFTelematicoToForfetari(res.primoCF, state);
        fillDataCollabTelematicoToForfetari(res.collab1CF, state, 1);
        fillDataCollabTelematicoToForfetari(res.collab2CF, state, 2);
        logger.info("Caricamento avvenuto con successo", "Carica telematico");
      }
      setCaricaDatiTelematicoOpen(false);
    })
    .catch(error => {
      logger.error('Errore ' + error.statusText);
    })
    .finally(() => setGlobalWait(false))    
  }

  React.useEffect(() => {    
    setApplication(Applicazioni.iForfettari);    
    if (identity) {
      console.log('Identity HOME is set ');
      verifyApplicationPrincipal();    
    } else {
      console.log('Identity HOME is null');
    }
    
    if (username && username !== '' && (!userLogged || userLogged !== username)) {
      // if (username && username !== '') {
      setUserLogged(identity?.Username!);
      console.log('Loggo in Tabella login e verifico utente');
      // loggaAccesso(Auth.getProvincia(global)!, username, Applicazioni.iForfettari, global).then(res => {
      loggaAccesso(Auth.getProvincia(global)!, identity?.Username!, Applicazioni.iForfettari, global).then(res => {
          console.log('Loggo ritorna: ' + res);
        if (res === false) {
          global.auth.userManager.signoutRedirect();        
        }
      })      
      // verifyUser(ip, auth, auth.user!, username);
    } else {
      console.log('Loggo non eseguito');
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [username]);
  
  const classes = useStyles();
  let isloading = state.loading/*|| stateSimSrl.loading*/;
  //console.log('application', application)
  return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
      <IForfettariAppBar title={title} handleLoad={handleChange} stateIForfetari={state}
         handleChange={handleTabChange} loadState={handleLoadState} resetState={handleResetState} apptabs={apptabs}></IForfettariAppBar>
        <ProgressBar isOpen={isloading}></ProgressBar>
        <Main>
          {/* Main content */}
          <Grid
            className={classes.justifyTabs}
            container
            direction="row"
            alignItems="center"        
          >
            <Paper className={clsx(classes.tabsBar, {
              [classes.tabsBarShift]: open && isBrowser,
            })}>
              <Tabs value={tab} onChange={handleTabChange} textColor="secondary" scrollButtons='on'>
                {
                  apptabs.map((text, index) => (
                    <Tab className={classes.tabColorati} key={index} label={<Typography className={classes.testoColorato} variant="button" color={index === 0 ? "primary" : "secondary"}>{text}</Typography>}{...a11yProps(index)}></Tab>
                  ))
                }
              </Tabs>
            </Paper>
          </Grid>
          <Grid
            id="print"
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
          >
            <React.Fragment>
                <TabPanel show={tab === 0} index={0}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <DialogTelematico state={state} caricaDatiTelematicoOpen={caricaDatiTelematicoOpen} handleClose={handleClose} handleSubmitLoadTelematico={handleSubmitLoadTelematico} isConvenienza={false}></DialogTelematico>
                    <InformazioniIniziali state={state} handleChange={handleChange} username={username} handleOpenLoadData={handleOpenLoadData}></InformazioniIniziali>
                    <GestionePrevidenziale state={state} handleChange={handleChange} username={username}></GestionePrevidenziale>
                    <RegimeForfettario state={state} handleChange={handleChange} username={username}></RegimeForfettario>
                    <RedditoContributiImposta state={state} handleChange={handleChange} username={username}></RedditoContributiImposta>
                    <RegimeNormale state={state} handleChange={handleChange} username={username}></RegimeNormale>
                    <LiquidazioneIrpef state={state} handleChange={handleChange} username={username}></LiquidazioneIrpef>
                    <DatiCollaboratore1 state={state} handleChange={handleChange} username={username}></DatiCollaboratore1>
                    <DatiCollaboratore2 state={state} handleChange={handleChange} username={username}></DatiCollaboratore2>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 1} index={1}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    {/* <SectionTitle text="Regime forfettario - liquidazione dell'IRPEF sugli altri redditi" primary={true}></SectionTitle> */}
                    <ImprenditoreProfessionista state={state} handleChange={handleChange} username={username}></ImprenditoreProfessionista>
                    <Collaboratore1 state={state} handleChange={handleChange} username={username}></Collaboratore1>
                    <Collaboratore2 state={state} handleChange={handleChange} username={username}></Collaboratore2>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 2} index={2}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <SectionTitle text="Regime normale - liquidazione dell'IRPEF su tutti i redditi" primary={true}></SectionTitle>
                    <IrpefImprenditore state={state} handleChange={handleChange} username={username}></IrpefImprenditore>
                    <IrpefCollaboratore1 state={state} handleChange={handleChange} username={username}></IrpefCollaboratore1>
                    <IrpefCollaboratore2 state={state} handleChange={handleChange} username={username}></IrpefCollaboratore2>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 3} index={3}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <SectionTitle text="Confronto" style={{color:'#fff'}} primary={true}></SectionTitle>
                    <Confronto state={state} handleChange={handleChange} username={username}></Confronto>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 4} index={4}>
                  <Grid className={clsx(classes.appBar, {
                    [classes.appBarShift]: open && isBrowser,
                  })}>
                    <ReportElaborazione state={state} handleChange={handleChange} username={username}></ReportElaborazione>
                  </Grid>
                </TabPanel>
                {tab !== 4 ?
                (<Tooltip title="Calcola forfetari">
                  <Fab 
                      className={classes.button}
                      style={{position: 'fixed', bottom: 20, right: 20}}
                      color="inherit"
                      size="large"
                      onClick={(e: any) => handleClickCalculateForfetari(state)}
                  >
                    <motion.div
                      variants={fabVariants}
                      initial="hidden"
                      animate="visible"
                      style={{verticalAlign: 'middle'}}
                    >
                      <ComputerIcon />
                    </motion.div>
                  </Fab>
                </Tooltip>)
                : null}
              </React.Fragment>
              {/*
              : application === Applicazioni.FlatTax //FlatTax (nascosto)
              ?
              <React.Fragment>
                <TabPanel show={tab === 0} index={0}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <DatiInformazioniInizialiFlatTax state={state} handleChange={handleChange} username={username}></DatiInformazioniInizialiFlatTax>
                    <GestionePrevidenzialeFlatTax state={state} handleChange={handleChange} username={username}></GestionePrevidenzialeFlatTax>
                    <DeterminazioneDelRedditoFlatTax state={state} handleChange={handleChange} username={username}></DeterminazioneDelRedditoFlatTax>
                    <IrapRegimeNormaleFlatTax state={state} handleChange={handleChange} username={username}></IrapRegimeNormaleFlatTax>
                    <ContributiFlatTax state={state} handleChange={handleChange} username={username}></ContributiFlatTax>
                    <ImpostaSostitutivaFlatTax state={state} handleChange={handleChange} username={username}></ImpostaSostitutivaFlatTax>
                    <LiquidazioneIrpefDatiImprenditoreProfessionistaFlatTax state={state} handleChange={handleChange} username={username}></LiquidazioneIrpefDatiImprenditoreProfessionistaFlatTax>
                    <ImpresaFamiliareFlatTax state={state} handleChange={handleChange} username={username}></ImpresaFamiliareFlatTax>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 1} index={1}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <ImprenditoreProfessionistaFlatTaxIrpef state={state} handleChange={handleChange} username={username}></ImprenditoreProfessionistaFlatTaxIrpef>
                    <Collaboratore1FlatTaxIrpef state={state} handleChange={handleChange} username={username}></Collaboratore1FlatTaxIrpef>
                    <Collaboratore2FlatTaxIrpef state={state} handleChange={handleChange} username={username}></Collaboratore2FlatTaxIrpef>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 2} index={2}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <ImprenditoreProfessionistaFlatTaxTuttoIrpef state={state} handleChange={handleChange} username={username}></ImprenditoreProfessionistaFlatTaxTuttoIrpef>
                    <Collaboratore1FlatTaxTuttoIrpef state={state} handleChange={handleChange} username={username}></Collaboratore1FlatTaxTuttoIrpef>
                    <Collaboratore2FlatTaxTuttoIrpef state={state} handleChange={handleChange} username={username}></Collaboratore2FlatTaxTuttoIrpef>
                  </Grid>
                </TabPanel>
                <TabPanel show={tab === 3} index={3}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <ReportElaborazioneFlatTax state={state} handleChange={handleChange} username={username}></ReportElaborazioneFlatTax>
                  </Grid>
                </TabPanel>
              </React.Fragment>
              */}          
            </Grid>
        </Main>
    </div>
  );
}

